import { ChipStatusText } from "@flat-ui";
import { AnnotationStatus } from "@faro-lotv/ielement-types";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Different colors of the status */

/**
 * Contains different colors for (icon, icon-background, icon-border) based on the status.
 *
 * Each status takes its tinted fill and outline from the theme's chip tints for the matching
 * intent, and its dot from that intent's main colour, so the set follows the colour scheme.
 */
export const markupStatusColor = {
  [AnnotationStatus.Open]: {
    icon: PALETTE_VARS.text.secondary,
    iconBackground: PALETTE_VARS.Chip.default.background,
    iconBorder: PALETTE_VARS.Chip.default.outline
  },
  [AnnotationStatus.InProgress]: {
    icon: PALETTE_VARS.primary.main,
    iconBackground: PALETTE_VARS.Chip.primary.background,
    iconBorder: PALETTE_VARS.Chip.primary.outline
  },
  [AnnotationStatus.ToReview]: {
    icon: PALETTE_VARS.tertiary.main,
    iconBackground: PALETTE_VARS.Chip.tertiary.background,
    iconBorder: PALETTE_VARS.Chip.tertiary.outline
  },
  [AnnotationStatus.Resolved]: {
    icon: PALETTE_VARS.success.main,
    iconBackground: PALETTE_VARS.Chip.success.background,
    iconBorder: PALETTE_VARS.Chip.success.outline
  },
  [AnnotationStatus.Unclassified]: {
    icon: PALETTE_VARS.text.disabled,
    iconBackground: PALETTE_VARS.background.paper,
    iconBorder: PALETTE_VARS.divider
  }
};

/** All the dropdown options for markup status */

/** List of available options to use for the DropDownMarkupField's value property */
export const STATUS_OPTIONS = Object.values(AnnotationStatus).map(status => ({
  key: status,
  value: status,
  label: ChipStatusText[status]
}));